<template>
    <section class="relative block py-2">
        <div
            class="relative z-30 flex items-center justify-end px-5 py-3 mx-auto bg-white md:py-5 sm-max:px-3 max-w-screen-3xl md:px-7 lg:px-14 2xl:px-36 lg:items-center">
            <div class="flex-grow block">
                <nuxt-img class="sm-max:w-40" preload format="webp" width="174" height="71" :src="logoSrc" :alt="logoAlt"  />
            </div>
            <a :href="phoneHref"
                class="border bnt-basic xs-max:text-14 !py-3 sm-max:px-3 !text-xl" :style="{ color: primaryColor, borderColor: primaryColor }">
                <span v-html="phoneText"></span>
            </a>
            <button type="button" @click="scrollTo(scrollTarget,scrollPosition(mobilePosition))"
                :style="{ background: primaryColor }"
                class="ml-6 text-white bnt-basic !py-3 !capitalize xs-max:text-14 md-max:px-8 sm-max:px-3 sm-max:ml-3 md:!block !hidden md:!text-xl">
                <span v-html="buttonText"></span>
            </button>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    logoSrc: {
        type: String,
        default: "/assets/images/logo.png"
    },
    logoAlt: {
        type: String,
        default: "Lifeboost Coffee Logo"
    },
    scrollTarget: {
        type: String,
        default: "the-products"
    },
    phoneHref: {
        type: String,
        default: "tel:1-800-479-1596"
    },
    phoneText: {
        type: String,
        default: "1-800-479-1596"
    },
    buttonText: {
        type: String,
        default: "Try It Now"
    },
    primaryColor: {
        type: String,
        default: "#e28831" // Това е примерна стойност за lifeboost-orange-middle
    },
    mobilePosition: {
        type: String,
        default: 'bottom'
    }
})

defineBuilderComponent({
    friendlyName: "Header-4-small-buttons",
    inputs: [
        {
            name: "primaryColor",
            type: "color",
            defaultValue: "#e28831"
        },
        {
            name: "logoSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
            defaultValue: "/assets/images/black-logo.svg"
        },
        {
            name: "logoAlt",
            type: "text",
            defaultValue: "Lifeboost Coffee Logo"
        },
        {
            name: "phoneHref",
            type: "text",
            defaultValue: "tel:1-800-479-1596"
        },
        {
            name: "scrollTarget",
            type: "text",
            defaultValue: "the-products"
        },
        {
            name: 'mobilePosition',
            type: 'enum',
            friendlyName: 'Scroll Position mobile',
            enum: [
                { label: 'Bottom', value: 'bottom' },
                { label: 'Top', value: 'top' }
            ],
            defaultValue: 'Bottom'
        },
        {
            name: "phoneText",
            type: "text",
            defaultValue: "1-800-479-1596"
        },
        {
            name: "buttonText",
            type: "text",
            defaultValue: "Try It Now"
        },]
})

</script>